<script setup>
import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'

const { t } = useI18n()

defineProps({
  label: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
})
const units = [
  { text: t('charts.units.seconds'), value: 1000 },
  { text: t('charts.units.minutes'), value: 1000 * 60 },
  { text: t('charts.units.hours'), value: 1000 * 60 * 60 },
  { text: t('charts.units.days'), value: 1000 * 60 * 60 * 24 },
  { text: t('charts.units.weeks'), value: 1000 * 60 * 60 * 24 * 7 },
]
const unit = ref(1000 * 60)

const num = ref(10)
const model = defineModel({ type: Number, default: 1000 * 60 * 10 })

watch(
  model,
  value => {
    if (unit.value * num.value === value) return
    let smallestDifference = Infinity
    let smallestDifferenceValue = null
    for (const unit of units) {
      const difference = Math.abs(value - unit.value)
      if (difference < smallestDifference) {
        smallestDifference = difference
        smallestDifferenceValue = unit.value
      }
    }
    unit.value = smallestDifferenceValue
    num.value = value / smallestDifferenceValue
  },
  { immediate: true }
)

watch([unit, num], () => {
  model.value = unit.value * num.value
})
</script>

<template>
  <v-label v-if="label">{{ label }}</v-label>
  <v-row density="comfortable">
    <v-col>
      <v-text-field
        v-model="num"
        type="number"
        variant="outlined"
        :disabled="disabled"
      />
    </v-col>
    <v-col>
      <v-autocomplete
        v-model="unit"
        :disabled="disabled"
        :items="units"
        item-title="text"
        variant="outlined"
      />
    </v-col>
  </v-row>
</template>

<style scoped></style>
